<template>
	<div class="part multipla-escolha">
		<div v-html="part.PartEnunciado" class="enunciado">
		</div>
		<div v-html="part.PartConteudo" class="conteudo">
		</div>
		<answer-box :locked="locked" :part="part" 
		:com-enunciado="true" 
		:large="true"></answer-box>
	</div>
</template>

<script>
	import AnswerBox from '../AnswerBox'

	export default {
		props: ['part', 'locked'],
		components: {
			'answer-box': AnswerBox
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/perguntas/multipla-escolha/PerguntaMultiplaEscolha.vue